import { Vehicle } from '../../model/Quote'
import { VoVehicle } from '../../model/VoVehicle'
import { ImageUrlType } from '../../pages/vehicle-configurator/VehicleGallery'

const getVehicleMake = (vehicle: Vehicle | VoVehicle) => vehicle.make?.code

const getModelYear = (vehicle: Vehicle | VoVehicle) => vehicle.modelYear

const getVehicleModelCode = (vehicle: Vehicle | VoVehicle) =>
  vehicle.model?.code

const getVehicleModel = (vehicle: Vehicle | VoVehicle) => vehicle.model?.text

const getVehicleBodyType = (vehicle: Vehicle | VoVehicle) =>
  vehicle.bodyType?.code

const getVehicleTrim = (vehicle: Vehicle | VoVehicle) => vehicle.trim?.code

const getVehicleVersion = (vehicle: Vehicle | VoVehicle) => {
  if (typeof vehicle.version === 'string') {
    return vehicle.version
  } else {
    return vehicle.version.code
  }
}

const getPowertrainType = (vehicle: Vehicle | VoVehicle) =>
  vehicle.powertrainType?.code

const getExteriorColour = (vehicle: Vehicle): string => {
  const exteriorColourOptions = vehicle?.selectedOptions?.find((option) =>
    option?.colour?.colourType?.includes('Exterior'),
  )
  return exteriorColourOptions?.optionCode || undefined
}

const createImageUrl = (url: string): ImageUrlType => ({
  original: url,
})

const getLocaleCountry = (locale: string) => locale.split('_')[1]

const getVehicleId = (vehicle: Vehicle | VoVehicle) => vehicle.vehicleId

export {
  getVehicleMake,
  getVehicleModel,
  getVehicleModelCode,
  getVehicleTrim,
  getModelYear,
  getVehicleBodyType,
  getPowertrainType,
  getExteriorColour,
  createImageUrl,
  getLocaleCountry,
  getVehicleVersion,
  getVehicleId,
}
